/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Drawer, Divider } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Button,
    TextField,
    Select,
    MenuItem,
} from "@mui/material";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import SearchBar from "../../components/SearchBar";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const FinancialReports = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [openDrawer, setOpenDrawer] = useState(false);

    const handleOpenDrawer = () => setOpenDrawer(true);
    const [reportType, setReportType] = useState<string>("");

    const handleCloseDrawer = () => {
        setOpenDrawer(false);
        setReportType("");
    };

    const reportConfig: Record<string, {
        label: string;
        fields: {
            vendor?: boolean;
            status?: boolean;
            gateway?: boolean;
            forecastPeriod?: boolean;
            vatType?: boolean;
        };
    }> = {
        gmv: {
            label: "GMV Report",
            fields: { vendor: true }
        },
        commission: {
            label: "Commission Income Report",
            fields: { vendor: true, status: true }
        },
        payout_liability: {
            label: "Payout Liability Report",
            fields: { vendor: true, status: true }
        },
        vat: {
            label: "VAT Output & Input Report",
            fields: { vendor: true, vatType: true }
        },
        refund: {
            label: "Refund & Adjustment Summary",
            fields: { vendor: true, status: true, gateway: true }
        },
        subscription: {
            label: "Subscription & Fee Income Report",
            fields: { status: true }
        },
        forecast_revenue: {
            label: "Platform Revenue Forecast",
            fields: { forecastPeriod: true }
        },
        forecast_payout: {
            label: "Payout & Liquidity Forecast",
            fields: { forecastPeriod: true }
        },
        pnl: {
            label: "Profit & Loss Statement",
            fields: {}
        },
        balance_sheet: {
            label: "Balance Sheet Snapshot",
            fields: {}
        }
    };

    const reportsData = [
        {
            id: "RPT-001",
            name: "Vendor Payout Summary",
            type: "Payout",
            period: "Jan 2025",
            generatedOn: "02 Feb 2025",
            status: "Completed",
            statusClass: "success",
        },
        {
            id: "RPT-002",
            name: "Commission Report",
            type: "Finance",
            period: "Jan 2025",
            generatedOn: "03 Feb 2025",
            status: "Pending",
            statusClass: "warning",
        },
        {
            id: "RPT-003",
            name: "Refund Analysis",
            type: "Refund",
            period: "Feb 2025",
            generatedOn: "05 Feb 2025",
            status: "Failed",
            statusClass: "danger",
        },
    ];

    const transactionLogs = [
        {
            id: "TXN-1001",
            type: "Payout",
            amount: "AED 2,880.00",
            gateway: "Stripe",
            reference: "STRP-849302",
            date: "15 Mar 2025",
            status: "Completed",
            statusClass: "success",
        },
        {
            id: "TXN-1002",
            type: "Refund",
            amount: "AED 450.00",
            gateway: "PayPal",
            reference: "PP-REF-22991",
            date: "18 Mar 2025",
            status: "Pending",
            statusClass: "warning",
        },
        {
            id: "TXN-1003",
            type: "Payout",
            amount: "AED 1,305.00",
            gateway: "Stripe",
            reference: "STRP-774120",
            date: "20 Mar 2025",
            status: "Failed",
            statusClass: "danger",
        },
        {
            id: "TXN-1004",
            type: "Commission",
            amount: "AED 320.00",
            gateway: "Wallet",
            reference: "WLT-003212",
            date: "22 Mar 2025",
            status: "Completed",
            statusClass: "success",
        },
    ];

    return (
        <>
            <div className="main_title">
                <h1> Financial Reporting</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  Financial Reporting
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* TOTAL REVENUE */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            AED 0.00
                            <p>Total Revenue</p>
                        </h2>
                        <figure className="sucess">
                            <PaidOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>

                {/* REFUNDS */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            AED 0.00
                            <p>Refunds</p>
                        </h2>
                        <figure className="danger">
                            <ReplayOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>

                {/* REPORTS GENERATED */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            0
                            <p>Reports Generated</p>
                        </h2>
                        <figure className="blue">
                            <ArticleOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>

                {/* TRANSACTIONS */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            0
                            <p>Transactions</p>
                        </h2>
                        <figure className="purple">
                            <SwapHorizOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>

            </div>



            <Box className="custom_tabs mt_20">
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    className="custom_tabs_links"
                >
                    <Tab label="Generated Reports" {...a11yProps(0)} />
                    <Tab label="Transaction Logs" {...a11yProps(1)} />
                </Tabs>

            </Box>
            <CustomTabPanel value={valueTabs} index={0}>

                <div className="cards mt_20">
                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search reports..."
                                />
                            </Box>
                        </div>
                        <div className="right_s">

                            <Button className="btn btn_grey" variant="outlined">Export CSV</Button>
                            <Button className="btn btn_primary" onClick={handleOpenDrawer}>Generate Report</Button>

                        </div>
                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Report Name</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Period</TableCell>
                                    <TableCell>Generated</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {reportsData.map((item) => (
                                    <TableRow key={item.id} hover>
                                        {/* Report Name */}
                                        <TableCell>
                                            <b>{item.name}</b>
                                        </TableCell>

                                        {/* Type */}
                                        <TableCell>{item.type}</TableCell>

                                        {/* Period */}
                                        <TableCell>{item.period}</TableCell>

                                        {/* Generated */}
                                        <TableCell>{item.generatedOn}</TableCell>

                                        {/* Status */}
                                        <TableCell>
                                            <span className={`badge1 ${item.statusClass}`}>
                                                {item.status}
                                            </span>
                                        </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

            </CustomTabPanel >

            <CustomTabPanel value={valueTabs} index={1}>
                <CustomTabPanel value={valueTabs} index={1}>
                    <div className="cards">
                        <div className="table_header">
                            <div className="left_s">
                                <Box className="search_box">
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search transaction ID or reference..."
                                    />
                                </Box>
                            </div>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Transaction ID</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Gateway</TableCell>
                                        <TableCell>Reference</TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {transactionLogs.map((item) => (
                                        <TableRow key={item.id} hover>
                                            {/* Transaction ID */}
                                            <TableCell>
                                                <b>{item.id}</b>
                                            </TableCell>

                                            {/* Type */}
                                            <TableCell>{item.type}</TableCell>

                                            {/* Amount */}
                                            <TableCell>
                                                <b>{item.amount}</b>
                                            </TableCell>

                                            {/* Gateway */}
                                            <TableCell>{item.gateway}</TableCell>

                                            {/* Reference */}
                                            <TableCell>{item.reference}</TableCell>

                                            {/* Date */}
                                            <TableCell>{item.date}</TableCell>

                                            {/* Status */}
                                            <TableCell>
                                                <span className={`badge1 ${item.statusClass}`}>
                                                    {item.status}
                                                </span>
                                            </TableCell>
                                            <TableCell>
                                                <Box>
                                                    <IconButton onClick={()=> navigate("view")}>
                                                        <img src="/static/images/eye_icon.svg" alt="icon" />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </CustomTabPanel>

            </CustomTabPanel>

            <Drawer
                anchor="right"
                open={openDrawer}
                onClose={handleCloseDrawer}
                PaperProps={{ sx: { width: 420 } }}
            >
                {/* HEADER */}
                <Box className="drawer_header">
                    <h3>Generate Financial Report</h3>
                    <IconButton onClick={handleCloseDrawer}>
                        <CancelOutlinedIcon />
                    </IconButton>
                </Box>

                <Divider />

                {/* BODY */}
                <Box className="drawer_body form">

                    {/* REPORT TYPE */}
                    <div className="control_group">
                        <label htmlFor="report-type">Report Type</label>
                        <Select
                            id="report-type"
                            size="small"
                            fullWidth
                            value={reportType}
                            onChange={(e) => setReportType(e.target.value)}
                            displayEmpty
                        >
                            <MenuItem value="">Select Report</MenuItem>
                            {Object.entries(reportConfig).map(([key, cfg]) => (
                                <MenuItem key={key} value={key}>
                                    {cfg.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>

               


                    <div className="control_group">
                        <label htmlFor="report-start-date">Start Date</label>
                        <TextField id="report-start-date" type="date" size="small" fullWidth />
                    </div>

                    {/* END DATE */}
                    <div className="control_group">
                        <label htmlFor="report-end-date">End Date</label>
                        <TextField id="report-end-date" type="date" size="small" fullWidth />
                    </div>
                    {/* ACTIONS */}
                    <div className="drawer_actions">
                        <Button
                            variant="outlined"
                            fullWidth
                            className="btn"
                            onClick={handleCloseDrawer}
                        >
                            Cancel
                        </Button>

                        <Button
                            className="btn btn_primary"
                            fullWidth
                            disabled={!reportType}
                        >
                            Generate Report
                        </Button>
                    </div>
                </Box>
            </Drawer>




        </>
    )
};
export default FinancialReports;